import React, { Component } from 'react';

import { RadioButtonGroup } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';

import validate from './validate';

import RadioButton from 'material-ui/RadioButton';

import { colors } from 'helpers/ColorHelper';

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
  ) : (
    false
  );

class PropertyDetails extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>
              Property Details and Preferences
            </h3>

            <h4
              style={{
                textAlign: 'center',
                marginBottom: '5px',
                marginTop: '45px',
              }}
            >
              Do you allow pets?
            </h4>
            <Field
              name="pets"
              component={RadioButtonGroup}
              style={{ margin: 'auto', textAlign: 'center' }}
            >
              <RadioButton
                value="Small Animals Only"
                label="Small Animals Only"
                labelStyle={{ width: 'initial' }}
                style={{ width: 'initial', display: 'inline-flex' }}
              />
              <RadioButton
                value="Allowed"
                label="Allowed"
                labelStyle={{ width: 'initial' }}
                style={{ width: 'initial', display: 'inline-flex' }}
              />
              <RadioButton
                value="Not Permitted"
                label="Not Permitted"
                labelStyle={{ width: 'initial' }}
                style={{ width: 'initial', display: 'inline-flex' }}
              />
            </Field>
            <Field name="pets" component={renderError} />

            <h4
              style={{
                textAlign: 'center',
                marginBottom: '5px',
                marginTop: '45px',
              }}
            >
              Are utilities included?
            </h4>
            <Field
              name="utilities"
              component={RadioButtonGroup}
              style={{ margin: 'auto', textAlign: 'center' }}
            >
              <RadioButton
                value="Not Included"
                label="Not Included"
                labelStyle={{ width: 'initial' }}
                style={{
                  marginLeft: '15px',
                  width: 'initial',
                  display: 'inline-flex',
                }}
              />
              <RadioButton
                value="Partially Included"
                label="Partially Included"
                labelStyle={{ width: 'initial' }}
                style={{
                  marginLeft: '15px',
                  width: 'initial',
                  display: 'inline-flex',
                }}
              />
              <RadioButton
                value="Included"
                label="Included"
                labelStyle={{ width: 'initial' }}
                style={{
                  marginLeft: '15px',
                  width: 'initial',
                  display: 'inline-flex',
                }}
              />
            </Field>
            <Field name="utilities" component={renderError} />
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PropertyDetails);
